export default [
  { value: 'public', label: 'Grabación de Función con Público' },
  { value: 'private', label: 'Grabación con Producción Propia' },
];



// WEBPACK FOOTER //
// ./src/utils/selectors/RecordTypeOptions.js